import { Blog } from './types'

export const getTime = (b?: Blog) => new Date(b?.publishedDate ?? b?.createdOn ?? 0).getTime()

export function sortByDateDesc<T extends Blog | undefined>(arr: T[]): Blog[] {
    return (arr.filter(Boolean) as Blog[]).slice().sort((a, b) => getTime(b) - getTime(a))
}

export function collectCurrentCategories(current?: Blog): Set<string> {
    const s = new Set<string>()
    if (!current) return s
    if (current.category) s.add(current.category)
    return s
}

export function isPrimaryRelated(b: Blog | undefined, current: Blog, cats: Set<string>) {
    if (!b) return false
    if (b.blogId === current.blogId) return false
    if (b.category && cats.has(b.category)) return true
    return false
}
